


























































import { BaseUser } from '../../../services/shared/auth';
import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import InquiryService from '../../../services/inquiry.service';
import InquiryReplyList from '../../inquiry/components/InquiryReplyList.vue';
import {
  AdminDto,
  InquiryDto,
  InquiryListDto,
  InquiryReplyListDto,
  InquiryUpdateClosedDto,
} from '../../../dto';
import { Pagination, YN, INQUIRY } from '../../../common';

import AdminService from '../../../services/admin.service';
import JwtStorageService from '../../../services/shared/auth/jwt-storage.service';
import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'InquiryDetail',
  components: {
    InquiryReplyList,
  },
})
export default class InquiryDetail extends BaseComponent {
  private inquiryDto = new InquiryDto();
  private inquiryUpdateDto = new InquiryDto();
  private pagination = new Pagination();
  private admin = new AdminDto(BaseUser);
  private inquiryReplyListDto = new InquiryReplyListDto();
  private inquiryReplyListCount = 0;
  private inquiryUpdateClosedDto = new InquiryUpdateClosedDto();

  // 문의 상세
  findOne(id) {
    InquiryService.findOne(id).subscribe(res => {
      this.inquiryDto = res.data;
    });
  }

  getReplyCount() {
    InquiryService.findForReply(
      this.$route.params.id,
      this.inquiryReplyListDto,
      this.pagination,
    ).subscribe(res => {
      this.inquiryReplyListCount = res.data.totalCount;
    });
  }

  // 답변 완료 처리
  updateClosed() {
    this.inquiryDto.isClosed = YN.YES;
    InquiryService.updateClosed(
      this.$route.params.id,
      this.inquiryUpdateClosedDto,
    ).subscribe(res => {
      if (res) {
        this.findOne(this.$route.params.id);
        toast.success('답변 완료 처리 되었습니다');
      }
    });
  }

  created() {
    const id = this.$route.params.id;
    this.findOne(id);
    this.getReplyCount();
  }
}
